//borderColor: (theme) => console.log(theme),
const keyNames = {
  REUSABLE: "REUSABLE",
  apiErrors: "apiErrors",
  themeMode: "themeMode",
  apiMsg: "apiMsg",
  extra: "extra",
  isLoading: "isLoading",
  toastData: "toastData",
  isAuthenticated: "isAuthenticated",
  //End multiple
  forceLogOut: "forceLogOut",
  userData: "userData",
  registeredUserData: "registeredUserData",
  widgetData: "widgetData",
  blogData: "blogData",
  caseStudyData: "caseStudyData",
  categoryData: "categoryData",
  galleryData: "galleryData",
  slugUniquedata: "slugUniquedata",
  prArticleData: "prArticleData",
  menuArticleData: "menuArticleData",
};
export default keyNames;
